import { render, staticRenderFns } from "./CoaApp.vue?vue&type=template&id=c5041bbe&scoped=true"
import script from "./CoaApp.vue?vue&type=script&lang=js"
export * from "./CoaApp.vue?vue&type=script&lang=js"
import style0 from "./CoaApp.vue?vue&type=style&index=0&id=c5041bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5041bbe",
  null
  
)

export default component.exports